import { createContext } from "react";

const CmsDetailsContext = createContext();

export default CmsDetailsContext;